import { createFileRoute } from '@tanstack/react-router'
import { ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { DnsTool } from '@/components/tool-page/dns-tool'
import { isCuratedDomain } from '@/lib/popular-sites'
import { domainPageContent, safeDomain } from '@/lib/tool-content'

const PARENT = { name: 'DNS Lookup', path: '/tools/dns-lookup' }

export const Route = createFileRoute('/_site/tools/dns-lookup_/$domain')({
  component: DnsLookupDomainPage,
  // One indexing rule: a per-domain page is indexable only for a domain on the curated list.
  head: ({ params }) => {
    const d = safeDomain(params.domain)
    return toolHead(domainPageContent('dns-lookup', params.domain), { noindex: !(d && isCuratedDomain(d)), parent: PARENT })
  },
})

function DnsLookupDomainPage() {
  const { domain } = Route.useParams()
  const content = domainPageContent('dns-lookup', domain)
  return (
    <ToolPage content={content} parent={PARENT}>
      <DnsTool content={content} initialName={safeDomain(domain) ?? ''} autoRun />
    </ToolPage>
  )
}
